import { Preloader, PreloaderFull } from '@/components/lib/molecules/Preloader'
import React, { Suspense, useEffect } from 'react'
import { ThemeSettings, useThemeContext } from '../../context'
import { useViewport } from '../../hooks'
import { changeHTMLAttribute } from '../../utils'

const Header = React.lazy(() => import('@/components/organisms/header_bar'))
const Footer = React.lazy(() => import('@/components/molecules/page_footer'))
const Navigation = React.lazy(() => import('@/components/organisms/side_menu'))

interface VerticalLayoutProps {
  children?: any
}

const VerticalLayout = ({ children }: VerticalLayoutProps) => {
  const { width } = useViewport()
  const { settings, updateSidebar } = useThemeContext()

  useEffect(() => {
    changeHTMLAttribute('data-color-scheme', settings.color)
    changeHTMLAttribute('data-bs-theme', settings.theme)
    changeHTMLAttribute('data-theme-font', settings.font)
    changeHTMLAttribute('data-content-layout', settings.layout.mode)
    changeHTMLAttribute('data-header-skin', settings.header.theme)
    changeHTMLAttribute('data-navigation-skin', settings.sidebar.theme)
    changeHTMLAttribute('data-navigation-menu', settings.sidebar.menu)
    changeHTMLAttribute('data-sidenav-size', settings.sidebar.size)
    changeHTMLAttribute('data-content-skin', settings.layout.contentSkin)
  }, [settings])

  useEffect(() => {
    if (width < 1200) {
      updateSidebar({ size: ThemeSettings.sidebar.size.full })
    } else if (width < 1400) {
      updateSidebar({ size: ThemeSettings.sidebar.size.iconbar })
    } else if (width > 1400) {
      updateSidebar({ size: ThemeSettings.sidebar.size.default })
    }
  }, [width])

  return (
    <Suspense fallback={<div />}>
      <div className="wrapper">
        <Suspense fallback={<PreloaderFull />}>
          <Navigation />
        </Suspense>

        <Suspense fallback={<div />}>
          <Header />
        </Suspense>

        <main className="main-content">
          <div
            className={`inner-content ${
              location.pathname.startsWith('/apps/') ? 'apps-content' : ''
            }`}>
            <Suspense fallback={<Preloader />}> {children}</Suspense>
          </div>
        </main>

        {!['/apps/'].some((path) => location.pathname.startsWith(path)) && (
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
        )}
      </div>
    </Suspense>
  )
}
export default VerticalLayout
